import { AfterViewInit, Component, OnInit } from '@angular/core'
import { BREAKPOINT, BreakpointService, CmsComponentData, TabParagraphContainerComponent } from '@spartacus/storefront'
import { CmsService, CMSTabParagraphContainer, WindowRef } from '@spartacus/core'
import { combineLatest, Observable, Subscription } from 'rxjs'
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators'
import { ViewportScroller } from '@angular/common'

@Component({
  selector: 'mb-pdp-tabs',
  templateUrl: './pdp-tabs.component.html',
  styleUrls: ['./pdp-tabs.component.scss']
})
export class PdpTabsComponent extends TabParagraphContainerComponent implements OnInit, AfterViewInit {

  subscription: Subscription = new Subscription()
  constructor (public componentData: CmsComponentData<CMSTabParagraphContainer>,
               protected cmsService: CmsService,
               protected winRef: WindowRef,
               protected breakpointService: BreakpointService,
               protected viewportScroller: ViewportScroller) {
    super(componentData, cmsService, winRef)
  }

  ngAfterViewInit (): void {
    super.ngAfterViewInit()
    this.subscription.add(
      this.selectFirstRenderedTab().subscribe()
    )
  }

  components$: Observable<any[]> = this.componentData.data$.pipe(
    distinctUntilChanged((x, y) => x?.components === y?.components),
    switchMap((data) =>
      combineLatest(
        (data?.components ?? '').split(' ').map((component: any) =>
          this.cmsService.getComponentData<any>(component).pipe(
            distinctUntilChanged(),
            map((tab) => {
              if (!tab) {
                return undefined
              }
              return {
                ...tab,
                flexType: tab.uid,
                title: `${tab.title}`,
              }
            })
          )
        )
      )
    ),
  )

  selectFirstRenderedTab (): Observable<any> {
    return this.components$.pipe(
      map((components: any[]) => components?.filter(component => !!component)),
      map((visibleComponents: any[]) => visibleComponents?.[0]),
      switchMap((firstVisibleComponent: any) => this.getIndexOfTabInAllTabs(firstVisibleComponent?.uid)),
      map((index: any) => this.activeTabNum === index ? null : this.select(index))
    )
  }

  getTotalNumberOfTabs (): Observable<number> {
    return this.components$.pipe(
      map((components: any[]) => components?.filter(component => !!component)?.length)
    )
  }

  getIndexOfTab (uid: string): Observable<number> {
    return this.components$.pipe(
      map((components: any[]) => (components?.filter(component => !!component)?.findIndex(component => component?.uid === uid)) + 1)
    )
  }

  getIndexOfTabInAllTabs (uid: string): Observable<number> {
    return this.components$.pipe(
      map((components: any[]) => (components?.findIndex(component => component?.uid === uid)))
    )
  }

  isScreenForSmallDevices (): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.sm)
  }
}
